

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Zoom, Slide } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import axios from "axios";

export default function EntertainmentPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const categoryId=13
  const pageNum = 1

  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(`https://www.mikeconnect.com/mc_api/get_posts_by_category.php?category=3&page=1&t=${Date.now()}`, {
  //       headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
  //     })
  //     .then(res => {
  //       if (res.data?.success) {
  //         // Take the latest 4 posts
  //         setPosts(res.data.posts.slice(0, 4));
  //       } else {
  //         setError(res.data?.error || "No posts found");
  //       }
  //     })
  //     .catch(() => setError("Network error"))
  //     .finally(() => setLoading(false));
  // }, []);

// const fetchPosts = () => {
//   setLoading(true);
//   setError(null);

//   axios
//     .get(
//       `https://www.mikeconnect.com/mc_api/get_posts_by_category.php?category=${categoryId}&t=${Date.now()}`
//     )
//     .then(res => {
//       if (res.data?.success) {
//         const fetchedPosts = res.data.posts || [];

//         // Take only the last 4 posts
//         const lastFourPosts = fetchedPosts.slice(0,4);

//         setPosts(lastFourPosts);
//       } else {
//         setPosts([]);
//         setError(res.data?.error || "No posts found");
//       }
//     })
//     .catch(() => {
//       setPosts([]);
//       setError("Network or server error");
//     })
//     .finally(() => setLoading(false));
// };


// useEffect(()=>{
//   fetchPosts()
// },[])



useEffect(() => {
  const cacheKey = "all_posts";
  let attempts = 0;
  const maxAttempts = 100;

  const interval = setInterval(() => {
    attempts++;

    try {
      const cached = localStorage.getItem(cacheKey);

      if (!cached) {
        console.log(`Attempt ${attempts}: no cached posts`);

        if (attempts >= maxAttempts) {
          setError("No posts");
          setLoading(false);
          clearInterval(interval);
        }

        return;
      }

      const allPosts = JSON.parse(cached);
      if (!allPosts.length) {
        if (attempts >= maxAttempts) {
          setError("No posts available");
          setLoading(false);
          clearInterval(interval);
        }
        return;
      }

      // ✅ Filter category 13
      const categoryPosts = allPosts.filter(post => {
        if (!post.category) return false;

        const cats = post.category.split(",").map(Number);
        return cats.includes(13);
      });

      // ⚠️ Optional: wait specifically for category 13 posts
      if (!categoryPosts.length) {
        if (attempts >= maxAttempts) {
          // setError("No category posts found");
          setLoading(false);
          clearInterval(interval);
        }
        return;
      }

      // ✅ Sort latest first
      const sorted = [...categoryPosts].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      // ✅ Take latest 4
      const lastFour = sorted.slice(0, 4);

      setPosts(lastFour);
      setLoading(false);

      // ✅ success → stop polling
      clearInterval(interval);

    } catch (err) {
      setError("Error loading posts");
      setLoading(false);
      clearInterval(interval);
    }
  }, 500);

  return () => clearInterval(interval);
}, []);






  // if (loading) return <Status>Loading entertainment posts...</Status>;
  if (error) return <Status>{error}</Status>;
  if (posts.length === 0) return ;

  return (
    <Container>
      <SectionTitle style={{color:"green"}}>🎬 Entertainment</SectionTitle>
      <Grid>
        {/* Feature Card */}
        {/* <Zoom duration={3000} triggerOnce> */}
          <FeatureCard>
            <RouterButton to={`/post/${posts[0].slug}`}>
              <FeatureImage src={posts[0].image || "https://source.unsplash.com/400x300/?entertainment"} />
              <FeatureContent>
                <FeatureTitle>{posts[0].title}</FeatureTitle>
                <FeatureDate>{new Date(posts[0].created_at).toDateString()}</FeatureDate>
              </FeatureContent>
            </RouterButton>
          </FeatureCard>
        {/* </Zoom> */}

        {/* Smaller Cards */}
        <SmallCards>
          {posts.slice(1).map((post, i) => (
            // <Slide key={i} direction="up" duration={3000} triggerOnce>
              <RouterButton to={`/post/${post.slug}`}>
                <SmallCard>
                  <SmallImage src={post.image || "https://source.unsplash.com/400x300/?entertainment"} />
                  <SmallContent>
                    <SmallTitle>{post.title}</SmallTitle>
                    <SmallDate>{new Date(post.created_at).toDateString()}</SmallDate>
                  </SmallContent>
                </SmallCard>
              </RouterButton>
            // </Slide>
          ))}
        </SmallCards>
      </Grid>
    </Container>
  );
}

/* ---------------- STYLES ---------------- */
const Container = styled.div`
  margin: 60px 0;
`;

const SectionTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 25px;
  
  // background: linear-gradient(90deg, #ff4d4d, #ff9900, #00ccff, #9933ff);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 10px 25px rgba(0,0,0,0.1);
  transition: 0.3s;
  &:hover { transform: scale(1.03); }
`;

const FeatureImage = styled.img`
  width: 100%;
  height: 350px;
  object-fit: cover;
  object-position:top;
`;

const FeatureContent = styled.div`
  position: absolute;
  bottom: 15px;
  left: 15px;
  color: white;
  text-shadow: 1px 1px 6px rgba(0,0,0,0.7);
`;

const FeatureTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
`;

const FeatureDate = styled.div`
  font-size: 14px;
  margin-top: 6px;
`;

const SmallCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

    @media(max-width:768px){
  flex-direction:row;
  flex-wrap:wrap;
  justify-content:center;
  align-items:center;
  }
`;

const SmallCard = styled.div`
  display: flex;
  gap: 12px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 6px 18px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: 0.3s;
  &:hover { transform: translateY(-5px); }
  @media (max-width: 768px) { flex-direction: column;
  width:300px;
  }
`;

const SmallImage = styled.img`
  width: 120px;
  height: 100px;
  object-fit: cover;
  flex-shrink: 0;
  @media (max-width: 768px) { width: 100%; height: 180px; }
`;

const SmallContent = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SmallTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
`;

const SmallDate = styled.div`
  font-size: 12px;
  opacity: 0.6;
`;

const RouterButton = styled(Link)`
  display: block;
  text-decoration: none;
  color: inherit;
`;

const Status = styled.div`
  text-align: center;
  font-size: 1.2rem;
  color: #555;
  margin-top: 40px;
`;
